export const priceFormatter = (currency, price) => {
  const locale = navigator.language;
  const digitFraction = 2;
  const formattedPrice = Number(price).toLocaleString(locale, {
    minimumFractionDigits: digitFraction,
    maximumFractionDigits: digitFraction
  });
  return `${currency}${isNaN(price) ? '0.00' : formattedPrice}`;
};
